import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Layout from '../layout'
Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Layout',
        redirect: '/home',
        component: Layout,
        children: [{
                path: "/home",
                name: 'home',
                component: Home
            }, {
                path: "/standard",
                name: 'standard',
                component: () =>
                    import ( /* webpackChunkName: "Standard" */ '@/views/Standard')
            }, {
                path: "/notice",
                name: 'notice',
                component: () =>
                    import ( /* webpackChunkName: "Notice" */ '@/views/Notice'),

            }, {
                path: "/learning-center",
                component: () =>
                    import ( /* webpackChunkName: "LearningCenter" */ '@/views/LearningCenter')
            }, {
                path: "/app-synopsis",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/AppSynopsis')
            }, {
                path: "/about",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/About')
            },
            {
                path: "/detail/:name/:title/:id",
                name: 'NoticeDetails',
                component: () =>
                    import ( /* webpackChunkName: "Noticedetails" */ '@/views/Noticedetails')
            },
            {
                path: "/coursedetails",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/coursedetails')
            },
            {
                path: "/openclass",
                component: () =>
                    import ( /* webpackChunkName: "AppSynopsis" */ '@/views/openclass')
            },
            {
                path: "/search-result",
                name: 'SearchResult',
                component: () =>
                    import ( /* webpackChunkName: "SearchResult" */ '@/views/SearchResult')
            },
            {
                path: '/redirect/:path(.*)',
                name: 'redirect',
                component: (resolve) => require(['@/views/redirect'], resolve)
            }
        ]
    },
    //隐私
    {
        path: "/privacys",
        name: 'privacys',
        component: () =>
            import ('../views/Privacys.vue')
    },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () =>
    //         import ('../utils/login/index.vue')
    // },
    // {
    //     path: '/redirect',
    //     component: Layout,
    //     children: [
    //         {
    //         path: '/redirect/:path(.*)',
    //         component: (resolve) => require(['@/views/redirect'], resolve)
    //         }
    //     ]
    // },
]
const router = new VueRouter({
    // mode: 'history', //关闭history 模式
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (to.path !== '/') {
            return { x: 0, y: 0 }
        }
        // return 期望滚动到哪个的位置
    },
    routes
})

export default router